import { ArsContextState, IArsActionSetSidebarView } from "../interface";

/**
 * Sets the active sidebar view.
 *
 * @param state - Current ARS context state
 * @param action - Set-sidebar-view action
 * @returns Updated state with sidebar view changed
 */
export const arsc_setSidebarView = <T>(
  state: ArsContextState<T>,
  action: IArsActionSetSidebarView,
): ArsContextState<T> => ({
  ...state,
  currentSidebar: {
    ...state.currentSidebar,
    view: action.view,
  },
});
